export const countries = () => 'FNOLSifarnici/GetDrzave';
export const cities = () => 'FNOLSifarnici/GetNaselja';
export const causes = () => 'FNOLSifarnici/GetKaskoUzrociStete';
export const claimConfirmation = () => 'FNOL/PotvrdaPrijaveStete';
export const claimConfirmationAnonymous = () => 'FNOL/PotvrdaPrijaveSteteAnonimni';
export const oneTimePassword = () => 'FNOL/GenerisiPrivremenuLozinku';
export const activePolicies = () => 'FNOLKasko/GetListaAktivnihPolisa';
export const addDocuments = () => 'FNOL/UploadDokumentacije';
export const policyDetails = () => 'FNOLKasko/GetDetaljiPolise';
export const onlineSubmitClaim = () => 'FNOLKasko/OnlinePrijavaStete';
export const documents = (id: string) => `FNOL/GetDokumentaZaUpload?stetaTempId=${id}`;
export const userData = () => 'FNOL/GetPodaciOUlogovanomKorisniku';
